module.exports = __webpack_public_path__ + "static/media/hubs1.89ae5f88.png";